import React from 'react';
import { CommonIconProps } from './Icon';

const SearchIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.32 14.9062C15.9094 15.4345 15.434 15.9099 14.9058 16.3205L20.293 21.7077C20.6835 22.0982 21.3167 22.0982 21.7072 21.7077C22.0977 21.3172 22.0977 20.684 21.7072 20.2935L16.32 14.9062Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
      fill={color}
    />
  </>
);

export default SearchIcon;
